import React, { useMemo, useState } from 'react';
import {
	DocumentationFile,
	useDocumentationFilesQuery,
} from '../../../graphql/graphql';
import LinkButton from '../../BaseModule/Components/Button/LinkButton/LinkButton';
import { Theme } from '../../BaseModule/Enums/Theme.enum';
import MediaViewerModal from '../../Utils/MediaViewer/MediaViewerModal';
import { prepareDocumentationFileForMediaViewer } from '../../ECard/Services/eCardFile.service';
import { useAppContext } from '../../../Services/AppContext';
import MultiMediaViewerModal from '../../Base/Components/MultiMediaViewer/MultiMediaViewerModal';
import Loading from '../../BaseModule/Components/Loading';

interface Props {
	documentationFileId: string;
}

const CaseChatMediaViewerButton: React.FC<Props> = ({
	documentationFileId,
}) => {
	const { socketUrl } = useAppContext();
	const [isMediaViewerOpen, setIsMediaViewerOpen] = useState(false);
	const [isMultiMediaViewerOpen, setIsMultiMediaViewerOpen] = useState(false);

	const { data, isLoading } = useDocumentationFilesQuery({
		fileIds: [documentationFileId],
	});

	const file: DocumentationFile | undefined = useMemo(() => {
		return data?.documentationFiles?.data?.[0] as DocumentationFile;
	}, [data]);

	const handleViewMedia = () => {
		const hasGroupFiles = (file.groupFiles?.length || 0) > 0;
		if (hasGroupFiles) {
			setIsMultiMediaViewerOpen(true);
		} else {
			setIsMediaViewerOpen(true);
		}
	};

	if (isLoading) {
		return <Loading />;
	}

	if (!file) {
		return <></>;
	}

	return (
		<>
			<LinkButton
				text='base.shared.show'
				theme='purple'
				onClick={handleViewMedia}
			/>
			{isMediaViewerOpen && (
				<MediaViewerModal
					file={prepareDocumentationFileForMediaViewer(file, socketUrl)}
					onClose={() => setIsMediaViewerOpen(false)}
					opened
				/>
			)}
			{isMultiMediaViewerOpen && (
				<MultiMediaViewerModal
					file={file}
					onClose={() => setIsMultiMediaViewerOpen(false)}
					isOpen
				/>
			)}
		</>
	);
};

export default CaseChatMediaViewerButton;
